import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installNumberFieldGuards } from './utils/numberFieldGuards';

// Number fields: no change on mouse wheel / arrow keys, digits only.
installNumberFieldGuards();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);